import type { HexColor, HexColorWithOpacity } from "./types";

// Type guard to check if a string is a valid hex color
// we only support 6 characters hex colors
export function isLongHexColor(value: string): value is HexColor {
  return /^#[0-9a-f]{6}$/i.test(value);
}

export function isHexColorWithOpacity(
  value: string
): value is HexColorWithOpacity {
  return /^#[0-9a-f]{8}$/i.test(value);
}

export const addHexOpacity = (
  color: string,
  opacity: number
): HexColorWithOpacity => {
  if (!isLongHexColor(color)) {
    throw new Error("Invalid hex color");
  }
  const result = `${color}${opacity.toString(16).padStart(2, "0")}`;
  if (!isHexColorWithOpacity(result)) {
    throw new Error("Invalid hex color with opacity");
  }
  return result;
};

export const removeHexOpacity = (color: string): HexColor => {
  if (!isHexColorWithOpacity(color)) {
    throw new Error("Invalid hex color with opacity");
  }
  const result = color.slice(0, 7);
  if (!isLongHexColor(result)) {
    throw new Error("Invalid hex color");
  }
  return result;
};
